document.addEventListener('DOMContentLoaded', function () {
  const locations = window.storeLocations || [];

  // Search functionality
  const searchInput = document.getElementById('store-search');
  const cards = document.querySelectorAll('.store-card');

  // Load Fuse.js for fuzzy search
// Load Fuse.js for fuzzy search
const fuseScript = document.createElement('script');
fuseScript.src = 'https://cdn.jsdelivr.net/npm/fuse.js@7.0.0/dist/fuse.min.js';
document.head.appendChild(fuseScript);

fuseScript.onload = function() {
  const fuseData = locations.map((loc, i) => ({
    index: i,
    text: `${loc.name} ${loc.address} ${loc.phone} ${loc.hours}`
  }));

  const fuse = new Fuse(fuseData, {
    keys: ['text'],
    threshold: 0.4,
    ignoreLocation: true
  });

  // Distance calculator (km between two lat/lng points)
  // Distance calculator (keep this same)
function getDistance(lat1, lng1, lat2, lng2) {
  const R = 6371;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLng/2) * Math.sin(dLng/2);
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
}

function showNearestStores(cityLat, cityLng, cityName) {
  const oldMsg = document.getElementById('nearby-message');
  if (oldMsg) oldMsg.remove();

  const sorted = locations
    .map((loc, i) => ({ i, dist: getDistance(cityLat, cityLng, loc.lat, loc.lng) }))
    .sort((a, b) => a.dist - b.dist)
    .slice(0, 3);

  const nearestIndexes = sorted.map(s => s.i);
  cards.forEach((card, i) => {
    card.style.display = nearestIndexes.includes(i) ? 'block' : 'none';
  });

  const msg = document.createElement('p');
  msg.id = 'nearby-message';
  msg.style.cssText = 'font-size:0.85rem;color:#888;margin-bottom:10px;';
  msg.textContent = `No stores in ${cityName}. Showing nearest locations.`;
  searchInput.insertAdjacentElement('afterend', msg);
}

let searchTimer = null;

searchInput.addEventListener('input', function () {
  const query = this.value.trim();

  const oldMsg = document.getElementById('nearby-message');
  if (oldMsg) oldMsg.remove();

  if (!query) {
    cards.forEach(card => card.style.display = 'block');
    return;
  }

  // Step 1 — fuzzy match against store data first
  const results = fuse.search(query).map(r => r.item.index);

  if (results.length > 0) {
    cards.forEach((card, i) => {
      card.style.display = results.includes(i) ? 'block' : 'none';
    });
    return;
  }

  // Step 2 — wait until at least 3 characters typed
  if (query.length < 3) {
    cards.forEach(card => card.style.display = 'none');
    return;
  }

  // Step 3 — geocode directly (Nominatim handles typos internally)
  clearTimeout(searchTimer);
  searchTimer = setTimeout(() => {
    fetch(`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(query)}&format=json&limit=1&countrycodes=in&addressdetails=1`)
      .then(res => res.json())
      .then(data => {
        const oldMsg2 = document.getElementById('nearby-message');
        if (oldMsg2) oldMsg2.remove();

        if (data && data.length > 0) {
          const cityLat = parseFloat(data[0].lat);
          const cityLng = parseFloat(data[0].lon);
          const placeName = data[0].address.city 
            || data[0].address.town 
            || data[0].address.village 
            || data[0].address.state 
            || query;

          showNearestStores(cityLat, cityLng, placeName);
        } else {
          cards.forEach(card => card.style.display = 'none');
          const msg = document.createElement('p');
          msg.id = 'nearby-message';
          msg.style.cssText = 'font-size:0.85rem;color:#888;margin-bottom:10px;';
          msg.textContent = `No stores found near "${query}".`;
          searchInput.insertAdjacentElement('afterend', msg);
        }
      });
  }, 700);
});
};


  // Init Leaflet map
  const map = L.map('store-map', {
  center: [22.5, 78.9629],
  zoom: 4.5,
  zoomSnap: 0.5,
  zoomDelta: 0.5,
  minZoom: 4,
  maxBounds: [
    [6.5, 68.0],
    [37.5, 97.5]
  ],
  maxBoundsViscosity: 1.0
});


  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '© OpenStreetMap contributors'
  }).addTo(map);

  // Step 2: India GeoJSON overlay (correct border including J&K/Ladakh)
fetch('https://raw.githubusercontent.com/datameet/maps/master/Country/india-composite.geojson')
  .then(function(res) { return res.json(); })
  .then(function(data) {
    L.geoJSON(data, {
      style: {
        color: '#E05C2A',       // border line color (adjust to match your brand)
        weight: 2,
        fill: false             // no fill — just the outline
      }
    }).addTo(map);
  })
  .catch(function(err) {
    console.warn('India GeoJSON failed to load:', err);
  });


  locations.forEach(function (store, index) {
    const marker = L.marker([store.lat, store.lng]).addTo(map);

    marker.bindPopup(`<b>${store.name}</b><br>${store.address}`);

    marker.on('click', function () {
      cards.forEach(c => c.classList.remove('active'));
      const card = document.querySelector(`.store-card[data-index="${index}"]`);
      if (card) {
        card.classList.add('active');
        card.scrollIntoView({ behavior: 'smooth' });
      }
    });

    cards[index] && cards[index].addEventListener('click', function () {
      map.setView([store.lat, store.lng], 14);
      marker.openPopup();
    });
  });
});
